export const paymentConstants = {
  GET_ACTIVE_MEMBER_NUMBER:"GET_ACTIVE_MEMBER_NUMBER",
  GET_ACTIVE_MEMBER_NOLIST:"GET_ACTIVE_MEMBER_NOLIST",
  ADD_PAYMENT_REQUEST: "ADD_PAYMENT_REQUEST",
  ADD_PAYMENT_SMS: "ADD_PAYMENT_SMS",
  ADD_PAYMENT_SUCCESS: "ADD_PAYMENT_SUCCESS",
  ADD_PAYMENT_FAILURE: "ADD_PAYMENT_FAILURE",
  PAYMENT_LIST_REQUEST: "PAYMENT_LIST_REQUEST",
  PAYMENT_LIST_SUCCESS: "PAYMENT_LIST_SUCCESS",
  PAYMENT_SUMMARY_REQUEST: "PAYMENT_SUMMARY_REQUEST",
  PAYMENT_SUMMARY_SUCCESS: "PAYMENT_SUMMARY_SUCCESS",
  PAYMENT_ERROR: "PAYMENT_ERROR",
  CANCEL_PAYMENT_REQUEST: "CANCEL_PAYMENT_REQUEST",
  CANCEL_PAYMENT_SUCCESS: "CANCEL_PAYMENT_SUCCESS",
  CHANGE_PAGE: "CHANGE_PAGE",
  // CLEAR_SUCCESS_MESSAGE: "CLEAR_SUCCESS_MESSAGE"
};

// export const paymentDetail = {
//   uyeNo: "",
//   baslangicTarihi:new Date(),
//   aylikTutar: 0,
//   taksitSayisi: 0,
//   kartAdi: "",
//   kartNo: 0,
//   sktAy: 0,
//   sktyYil:0,
//   cvv: 0
// }
export const createPaymentPages={
  orderDetail:"orderDetail",
  creditCard:"creditCard",
  sms:"sms",
  done:"done",
}